var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmbRow',{attrs:{"controlValue":_vm.itemId,"isRadioButton":!_vm.isForDisplay},scopedSlots:_vm._u([{key:"picto",fn:function(){return [_c('FdText',{attrs:{"fa":""}},[_c('i',{class:[
          'fas',
          {
            'fa-user-tie': _vm.client && !_vm.project && !_vm.organization,
          },
          {
            'fa-folder': _vm.project && !_vm.organization,
          },
          {
            'fa-building': _vm.organization,
          },
        ]})])]},proxy:true}])},[_c('div',{staticClass:"row no-gutters align-items-center"},[_c('div',{staticClass:"d-flex col-6 pr-2 align-items-center gmb-obsbox-item__primary-info-column"},[(_vm.organization)?[_c('FdText',{attrs:{"oneline":"","tag":"span"}},[_vm._v(_vm._s(_vm.organization))])]:(_vm.project)?[_c('FdText',{attrs:{"oneline":"","tag":"span"}},[_vm._v(_vm._s(_vm.project))])]:[_c('FdText',{attrs:{"oneline":"","tag":"span"}},[_vm._v(_vm._s(_vm.client))])]],2),_c('div',{staticClass:"d-flex col-6 pl-2 justify-content-end gmb-obsbox-item__secondary-info-column"},[_c('div',{class:[
          'd-flex align-items-center',
          {
            'maxw-50 pr-1': _vm.client && _vm.project && _vm.organization,
          },
        ]},[(_vm.client && (_vm.project || _vm.organization))?[_c('FdText',{attrs:{"fa":""}},[_c('i',{staticClass:"fas fa-user-tie"})]),_c('FdText',{staticClass:"ml-1",attrs:{"fontSizeSmaller2":"","oneline":"","tag":"span"}},[_vm._v(_vm._s(_vm.client)+" ")])]:_vm._e()],2),_c('div',{class:[
          'd-flex maxw-50 align-items-center',
          {
            'pl-1': _vm.client && _vm.project && _vm.organization,
          },
        ]},[(_vm.project && _vm.organization)?[_c('FdText',{attrs:{"fa":""}},[_c('i',{staticClass:"fas fa-folder"})]),_c('FdText',{staticClass:"ml-1",attrs:{"fontSizeSmaller2":"","oneline":"","tag":"span"}},[_vm._v(_vm._s(_vm.project)+" ")])]:_vm._e()],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }